$(document).ready(function(){
  var pageURL = window.location.href;
  var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("#") + 1);
  
    if ($(document).find('.accordion_in_flxs').length) {
      var accordion = "#" + lastURLSegment + " .accordion_in_flxs";
      setTimeout(function () {
        $(document).find(accordion).trigger("click");
      }, 500);
       
      $(document).on("click", ".policy_clicks", function () {
        $(document).find("#policy .accordion_in_flxs").trigger("click");
      });
      $(document).on("click", ".warranty_clicks", function () {
        $(document).find("#warranty .accordion_in_flxs").trigger("click");
      });
      $(document).on("click", ".refund_clicks", function () {
        $(document).find("#refund .accordion_in_flxs").trigger("click");
      });
    }
  //Banner Slider Js
  $(".ctm_main_banners").slick({
    slidesToShow: 1,
    infinite: true,
    fade: false,
    autoplay: window.autoplay,
    autoplaySpeed: window.autospeed,
    speed: 800,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    adaptiveHeight: false,
    prevArrow:
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Previous slide" aria-controls="Slider-template--17137087840471__0fdb9599-9374-42ae-9504-28db237e0e7c"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Next slide" aria-controls="Slider-template--17137087840471__0fdb9599-9374-42ae-9504-28db237e0e7c"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  });

  // Testimonil Slider Js
  $(".testimonil-wrapper").slick({
    dots: true,
    arrow: false,
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  //accordian Js
  $(".accordian_contains").hide();
  $(".accordion_in_flxs").click(function () {
    $(".accordion_in_icons ").css("transform", "rotate(0deg)");
    if ($(".accordian_contains").is(":visible")) {
      $(".accordian_contains").slideUp(300);
    }
    if ($(this).next(".accordian_contains").is(":visible")) {
      $(this).next(".accordian_contains").slideUp(300);
      $(this)
        .closest(".accordion_inners")
        .find(".accordion_in_icons ")
        .css("transform", "rotate(0deg)");
    } else {
      $(this).next(".accordian_contains").slideDown(300);
      $(this)
        .closest(".accordion_inners")
        .find(".accordion_in_icons")
        .css("transform", "rotate(180deg)");
    }
    $('.accordion_in_flxs').removeClass('colored_text');
    $(this).addClass('colored_text');
  });

  $(".ctm_brand_grid_data").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: "linear",
    waitForAnimate: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".icon_data_div").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: "linear",
    waitForAnimate: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });


 $(".swiper-wrapperss").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow:
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Previous slide" aria-controls="Slider-template--17137087840471__0fdb9599-9374-42ae-9504-28db237e0e7c"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Next slide" aria-controls="Slider-template--17137087840471__0fdb9599-9374-42ae-9504-28db237e0e7c"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  });

  
  // Megamenu js
  $(".ctm_megamenu_items ul li").hover(function () {
    var data_title = $(this).attr("data-title");
    $(".ctm_menu_collection_data").each(function () {
      var data_value = $(this).attr("data-value");
      if (data_title == data_value) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });
  });

  let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });

  $(".pro_register_btn").mouseover(function () {
    $(this)
      .parents(".product__info-wrapper")
      .find(".product-form__submit")
      .css({ "background-color": "#202020", border: "1px solid #474747" });
  });
  $(".pro_register_btn").mouseout(function () {
    $(this)
      .parents(".product__info-wrapper")
      .find(".product-form__submit")
      .css({ "background-color": "#C7307B", border: "1px solid #C7307B" });
  });

  $(document).on("click", ".showall_showcase a", function () {
    $(".main_shocasw_div").toggleClass("shadow_scroll_down");
    $(".image_with_text_flx_annimated").toggleClass("showcase_hidden_block");
  });

  $(document).on("click", ".addons_product_list .product_box", function () {
    $(this).toggleClass("actives");
    if ($(document).find(".actives").length) {
      $(document).find(".product-form__buttons").addClass("add-on-p");
    } else {
      $(document).find(".product-form__buttons").removeClass("add-on-p");
    }
  });
});

// Addons Js
$(document).on("click", ".product-form__buttons.add-on-p", function () {
  if ($(this).hasClass("add-on-q")) {
    setTimeout(function () {
      $(".add-on-p").removeClass("add-on-q");
    }, 100);
  } else {
    var self = this;
    if ($(document).find(".custom-prop").length) {
      $(document).find(".custom-prop").remove();
    }
    var randNum = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    var propHtml =
      `<input class="custom-prop" type="hidden" name="properties[_main-product]" value="` +
      randNum +
      `">`;
    $(document).find(".product-form__buttons").append(propHtml);
    var itemsData = {};
    itemsData["items"] = [];
    $(document)
      .find(".add-on-product-list-wrap.active")
      .find(".product_box.actives")
      .each(function (index) {
        var variantIdRaw = $(this).attr("variant_id");
        var variantId = parseInt(variantIdRaw);
        var variantQuantity = $(this).find('.addons_quantity').val();
        itemsData["items"][index] = {};
        itemsData["items"][index]["quantity"] = variantQuantity;
        itemsData["items"][index]["id"] = variantId;
        itemsData["items"][index]["properties"] = {
          "_bundle-product": randNum,
        };
      });

    $(self).addClass("add-on-q");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: itemsData,
      dataType: "json",
      async: false,
      success: function () {
        $(self).find("button").trigger("click");
      },
      error: function () {
        alert("Something went wrong. Please try again later!");
      },
    });
  }

  var $status = $(".pagingInfo");
  var $slickElement = $(".slick-slider");

  $slickElement.on(
    "reInit afterChange init",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + "/" + slick.slideCount);
    }
  );
});

$(document).on("click",".location_collection_btn button",function(){
  var ths_id = $.trim($(this).attr('data-tag'));
  $(document).find('.location_collection_btn button').removeClass('active');
  $(this).addClass('active');
    $(document).find('ul#product-grid li').hide();
    $(document).find('ul#product-grid li').each(function(){
        var thsval = $.trim($(this).attr('data-tags'));
        if(thsval == ths_id){
          $(this).show();
        }
    });
});

$(document).on("keyup change","input.location_minimum_quantity",function(){
  var minLimit = 6;
  var currentnumber = $(this).val();
  if(currentnumber < minLimit){
    $(this).addClass('no_enter_value');        
    $('.product-form__submit').addClass('no_enter_value');        
  }else{
    $(this).removeClass('no_enter_value');   
      $('.product-form__submit').removeClass('no_enter_value');   
  } 
});



